const groupBy = (array, attr) => {
    return array.reduce((acc, item) => {
        const value = item[attr];
        if (!acc[value]) {
            acc[value] = [];
        }
        acc[value].push(item);
        return acc;
    }, {});
};

export default groupBy;